import React from "react";
import { connect } from "react-redux";
import { Tooltip } from "ui-components";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";

import {
  RiskSelectorWrapper,
  RiskSelectorContent,
  RiskSelectorIcon,
  RiskSelectorText,
  RiskSelectorButtons,
  RiskSelectorInfo,
  RiskSelectorLink
} from "@common/styled/risk";
import { radioStyles } from "./styled";

const RiskSelector = ({
  children,
  key,
  riskIdx,
  sectionKey,
  selectedValue,
  onChange,
  toggleRiskWarningDialog,
  isRiskWarningDialogShown,
  sectionMeta,
  stepsMeta
}) => {
  // Render the two RiskSelector buttons
  const renderRiskSelectorButtons = risk => {
    return (
      <RadioButtonGroup
        name={`${sectionKey}_${riskIdx}`}
        style={radioStyles.group}
        valueSelected={selectedValue}
        onChange={(event, value) => onChange(event, value, riskIdx)}
      >
        <RadioButton
          label="Yes"
          value="y"
          style={{ ...radioStyles.button, marginRight: "1rem" }}
          inputStyle={radioStyles.input}
          iconStyle={radioStyles.icon}
          labelStyle={radioStyles.label}
        />
        <RadioButton
          label="No"
          value="n"
          style={radioStyles.button}
          inputStyle={radioStyles.input}
          iconStyle={radioStyles.icon}
          labelStyle={radioStyles.label}
        />
      </RadioButtonGroup>
    );
  };

  // Render the RiskSelector information
  const renderRiskInfo = risk => {
    // Only render if a selection has been made (either "yes" or "no")
    if (risk.isRisk !== null) {
      // Determine which risk information to display based on the risk indication
      const infoText = risk.isRisk
        ? sectionMeta.riskInstructions[risk.riskText]
        : sectionMeta.noRiskInstructions[risk.noRiskText];

      // Only render the risk information if a risk indication was made
      return (
        <RiskSelectorInfo>
          {risk.isRisk
            ? <RiskSelectorLink>{infoText}</RiskSelectorLink>
            : infoText}
        </RiskSelectorInfo>
      );
    }
  };

  const risk = children;
  const isElevatedRisk = risk.isRisk && risk.isElevated;
  const elevatedRiskIcon = require("@public/assets/icons/alert.svg");
  const hasTooltip = !isRiskWarningDialogShown && isElevatedRisk;

  return (
    <RiskSelectorWrapper>
      <RiskSelectorContent>
        <Tooltip
          id={risk.elevatedKey}
          isRendered={hasTooltip}
          tooltip={risk.elevatedContent}
        >
          <RiskSelectorIcon
            src={elevatedRiskIcon}
            isShown={isElevatedRisk}
            onClick={toggleRiskWarningDialog}
          />
        </Tooltip>
        <RiskSelectorText isBulletShown={isElevatedRisk}>
          {risk.question}
        </RiskSelectorText>
        <RiskSelectorButtons>
          {renderRiskSelectorButtons(risk)}
        </RiskSelectorButtons>
      </RiskSelectorContent>
      {renderRiskInfo(risk)}
    </RiskSelectorWrapper>
  );
};

const mapStateToProps = state => {
  return {
    sectionMeta: state.workerHome.app.meta,
    isRiskWarningDialogShown: state.workerHome.app.ui.isRiskWarningDialogShown,
    stepsMeta: state.workerHome.sidebar.stepsMeta
  };
};

const RiskSelectorContainer = connect(mapStateToProps, null)(RiskSelector);
export default RiskSelectorContainer;



// WEBPACK FOOTER //
// ./src/workerhome/components/Content/RiskSelector/RiskSelectorContainer.jsx